"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    PENDING: 'pending',
    APPROVED: 'approved',
    ALLOCATED: 'allocated',
    WAITING: 'waiting',
    REJECTED: 'rejected',
};
//# sourceMappingURL=preallocationStatus.js.map